import { ApplicationRoutes } from '../../../app-routes-names'

export const ShopPerformanceRoutes = {
  invoicesListOverview: 'invoices-list-overview',
  invoicesList: 'invoices-list',
  invoiceLinesOverview: 'invoice-lines-overview',
  invoiceLinesByLocation: 'invoice-lines-by-location',
  invoiceLinesByAdvisor: 'invoice-lines-by-advisor',
  invoiceLinesList: 'invoice-lines-list',
  grossProfitInvoicesList: 'gross-invoices-list',
  gpPackageInvoicesList: 'package-gp-list',
  invoicesCustomerType: 'invoices-customer-type',
  invoicesDeferredType: 'invoices-deferred-type',
  invoicesGrossProfit: 'invoices-gross-profit',
  gpPackageLocation: 'package-gp-location',
  gpPackageCategory: 'package-gp-category',
  performancePackageGp: 'performance-package-gp',
  categoriesMovingAverage: 'categories-moving-average',
  categoryOverview: 'category-overview'
}

const { shopPerformance } = ApplicationRoutes

export const ShopPerformancePaths = {
  invoicesListOverview: `/${shopPerformance}/${ShopPerformanceRoutes.invoicesListOverview}`,
  invoicesList: `/${shopPerformance}/${ShopPerformanceRoutes.invoicesList}`,
  invoiceLinesOverview: `/${shopPerformance}/${ShopPerformanceRoutes.invoiceLinesOverview}`,
  invoiceLinesByLocation: `/${shopPerformance}/${ShopPerformanceRoutes.invoiceLinesByLocation}`,
  invoiceLinesByAdvisor: `/${shopPerformance}/${ShopPerformanceRoutes.invoiceLinesByAdvisor}`,
  invoiceLinesList: `/${shopPerformance}/${ShopPerformanceRoutes.invoiceLinesList}`,
  grossProfitInvoicesList: `/${shopPerformance}/${ShopPerformanceRoutes.grossProfitInvoicesList}`,
  gpPackageInvoicesList: `/${shopPerformance}/${ShopPerformanceRoutes.gpPackageInvoicesList}`,
  invoicesCustomerType: `/${shopPerformance}/${ShopPerformanceRoutes.invoicesCustomerType}`,
  invoicesDeferredType: `/${shopPerformance}/${ShopPerformanceRoutes.invoicesDeferredType}`,
  invoicesGrossProfit: `/${shopPerformance}/${ShopPerformanceRoutes.invoicesGrossProfit}`,
  gpPackageLocation: `/${shopPerformance}/${ShopPerformanceRoutes.gpPackageLocation}`,
  gpPackageCategory: `/${shopPerformance}/${ShopPerformanceRoutes.gpPackageCategory}`,
  performancePackageGp: `/${shopPerformance}/${ShopPerformanceRoutes.performancePackageGp}`,
  categoriesMovingAverage: `/${shopPerformance}/${ShopPerformanceRoutes.categoriesMovingAverage}`,
  categoryOverview: `/${shopPerformance}/${ShopPerformanceRoutes.categoryOverview}`
}
